<template>
  <div
    ref="inlineOption"
    :tabindex="tabIndex"
    :role="optionRole"
    :aria-checked="ariaChecked"
    :aria-labelledby="optionLabelId"
    :class="classes"
    @click="onClick"
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave"
    @keydown.space="onSpacePressed"
  >
    <div class="trbo-a-inline-option__wrapper">
      <img v-if="option.imageUrl" :src="option.imageUrl" class="trbo-a-inline-option__image" alt="">
      <div class="trbo-a-inline-option__title-actions">
        <div class="trbo-a-inline-option__title">
          <div :id="optionLabelId" class="trbo-a-inline-option__title__content">
            {{ option.title }}
          </div>
        </div>
        <div class="trbo-a-inline-option__actions">
          <div v-if="hasInfoText" class="trbo-a-inline-option__info-icon" @click.stop>
            <info-icon
              role="tooltip"
              tabindex="0"
              :main-icon="infoIcon"
              :is-opened="isOpened"
              :aria-labelledby="infoId"
              @click="onToggleIsOpened"
              @esc-pressed="closeToggle"
            />
          </div>
          <div v-if="isMultiple" class="trbo-a-inline-option__check">
            <checkbox
              :is-hovered="isHovered"
              :is-checked="isSelected"
              :is-disabled="isDisabled"
              :aria-labelledby="optionLabelId"
            />
          </div>
        </div>
      </div>
    </div>
    <animation-height
      v-if="hasInfoText"
      :key="option.uuid"
      :is-visible="isOpened"
      use-opacity
    >
      <div
        :id="infoId"
        :aria-hidden="!isOpened"
        class="trbo-a-inline-option__info-container"
      >
        <div class="trbo-a-inline-option__info-text">
          <info-text
            :is-opened="isOpened"
            :title="infoTitle"
            :description="infoDescription"
          />
        </div>
      </div>
    </animation-height>
  </div>
</template>

<script>
// @flow

import singleOptionMixin from '../../../../mixins/singleOptionMixin'

import AnimationHeight from '../../../AnimationHeight/AnimationHeight.vue'
import Checkbox from '../../../Checkbox/Checkbox.vue'

import InfoIcon from '../InfoIcon/InfoIcon.vue'
import InfoText from '../InfoText/InfoText.vue'

export default {
  components: {
    AnimationHeight,
    InfoIcon,
    InfoText,
    Checkbox
  },
  mixins: [singleOptionMixin],
  props: {
    variant: {
      type: String,
      default: 'inline',
      validator (value) {
        return ['inline', 'multiline'].includes(value)
      }
    },
    option: {
      type: Object, // QuestionOption
      required: true
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpened: false,
      isHovered: false
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-inline-option': true,
        'trbo-a-inline-option--without-image': !this.option.imageUrl,
        'trbo-a-inline-option--is-multiple': this.isMultiple,
        'trbo-a-inline-option--is-selected': this.isSelected,
        'trbo-a-inline-option--is-disabled': this.isDisabled,
        'trbo-a-inline-option--is-option-disabled': this.option.isDisabled,
        'trbo-a-inline-option--inline': this.variant === 'inline',
        'trbo-a-inline-option--multiline': this.variant === 'multiline',
        'trbo-a-inline-option--multiline--open': this.variant === 'multiline' && this.isOpened
      }
    },
    infoId () {
      return `info-${this.option.uuid}`
    },
    optionRole () {
      if (this.isMultiple) return 'checkbox'

      return 'radio'
    },
    optionLabelId () {
      return `checkbox-label-${this.option.uuid}`
    },
    ariaChecked () {
      if (this.isSelected) return 'true'

      return undefined
    },
    tabIndex () {
      if (this.isDisabled) return '-1'

      return '0'
    }
  },
  methods: {
    onClick (event) {
      if (!this.option.isDisabled) {
        this.$emit('select', this.option)
      }
    },
    onToggleIsOpened () {
      this.isOpened = !this.isOpened
    },
    onMouseOver () {
      this.isHovered = true
    },
    onMouseLeave () {
      this.isHovered = false
    },
    closeToggle () {
      this.isOpened = false
    },
    onSpacePressed (event) {
      if (!event.defaultPrevented && !this.option.isDisabled && event.target === this.$refs.inlineOption) {
        event.preventDefault()
        this.$emit('select', this.option)
      }
    }
  }
}
</script>

<style scoped src="./inline-option.scss" />
